import React from 'react';
import { Text, Icon } from '../../../common/components';

export interface YearGroupProps {
  year: number;
  changeCount: number;
  isExpanded: boolean;
  toggleExpand: () => void;
  children: React.ReactNode;
}

const changeCountText = (count: number): string => {
  if (count === 0) return 'Během tohoto roku nebyla nalezena změna';
  if (count === 1) return 'Byla nalezena 1 změna';
  if (count < 5) return `Byly nalezeny ${count} změny`;
  return `Bylo nalezeno ${count} změn`;
};

/**
 * Sbalený ročník historie kontrol – detailně se zobrazuje jen aktuální rok,
 * starší roky jsou jednořádkové a rozbalují se na kliknutí.
 */
export const YearGroup: React.FC<YearGroupProps> = ({ year, changeCount, isExpanded, toggleExpand, children }) => (
  <div className="BuildingLogsGroup mt-1 mb-1">
    <div
      className="BuildingLogsGroup__header BuildingLogsGroup__header--noChange"
      onClick={toggleExpand}
    >
      <Text className="mr-2" size="body-large" color="Neutral700">
        {`Rok ${year}`}
      </Text>

      <div style={{ flexGrow: 1 }}>
        <Text
          size="body-medium"
          weight={changeCount > 0 ? '700' : '400'}
          color={changeCount > 0 ? 'Neutral800' : 'Neutral700'}
        >
          {changeCountText(changeCount)}
        </Text>
      </div>

      <Icon
        className="BuildingLogsGroup__toggle-icon"
        name={isExpanded ? 'arrowDown' : 'arrowRight'}
        color="Primary500"
      />
    </div>

    {isExpanded && <div className="BuildingLogsGroup__yearItems">{children}</div>}
  </div>
);

export default YearGroup;
